function getImageFormat(dataImageFormat) {
  return dataImageFormat.split(':')[1];
}

const imageProcessorService = {
  compressImage(base64, _width, _height, callback) {
    const canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    const image = new Image();
    image.onload = function () {
      const MAX_WIDTH = _width;
      const MAX_HEIGHT = _height;
      let width = image.naturalWidth;
      let height = image.naturalHeight;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);
      const dataurl = canvas.toDataURL(getImageFormat(base64.split(';')[0]),
          0.8);
      return callback(dataurl.split(',')[1]);
    };
    image.src = base64;
  },
};

export default imageProcessorService;



// WEBPACK FOOTER //
// ./src/services/ImageProcessorService.js